import { createFormSubmitButton } from '@circlefin/form/Form.SubmitButton'
import { usePermission } from '@circlefin/permissions/react'
import { BILLING_DASHBOARD } from '@services/permissions'

import type { ButtonProps } from '@circlefin/components/lib/Button'

const SubmitButton = createFormSubmitButton()

export const UpdateCard: React.FC<ButtonProps> = ({ children, ...props }) => {
  const [, { isAuthorized }] = usePermission(BILLING_DASHBOARD)

  return (
    <SubmitButton {...props} disabled={!isAuthorized}>
      {children}
    </SubmitButton>
  )
}
